import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.medications.medicationSearch;
export const medicationSearchDataSelector = (state: RootState) => getState(state).data;
export const medicationSearchIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const medicationSearchTableDataSelector = (state: RootState) =>
  medicationSearchDataSelector(state)?.tableData || [];
export const medicationSearchPaginationSelector = (state: RootState) =>
  medicationSearchDataSelector(state)?.pagination;
